export default "__VITE_ASSET__42136904__"